import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '../../form/components/button/button.component';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent],
})
export class AlertModalComponent {
  text!: string;
  title!: string;
  confirmText!: string;
  confirmColor = 'primary';
  constructor(public activeModal: NgbActiveModal) {}
}
